import { Component, ElementRef, HostListener, Renderer2, inject } from '@angular/core';
import { SplashScreenService } from '@core/services/common/splash-screen.service';
import { dispatch } from '@ngxs/store';
import { UpdateLocalStorage } from '@app/store/project/project.actions';
import { AlertComponent } from './shared/notifications-shared/components/alert/alert.component';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { AppService } from '@app/app.service';
import { SetOfficeEnvironment } from '@app/store/user/user.actions';
import { isOfficeEnvironment } from 'ngx-q360-lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, AlertComponent],
})
export class AppComponent {
  protected readonly splashScreenService = inject(SplashScreenService);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private appService = inject(AppService);

  setOfficeEnvironment = dispatch(SetOfficeEnvironment);
  updateLocalStorage = dispatch(UpdateLocalStorage);

  constructor() {
    this.setOfficeEnvironment(isOfficeEnvironment());
    this.updateLocalStorage({ ...localStorage });

    window.addEventListener('storage', () => {
      if (localStorage) {
        this.updateLocalStorage({ ...localStorage });
      }
    });

    this.addGoogleMapsInlineScript();
    this.loadScript('https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js');
    this.renderer.setAttribute(this.elementRef.nativeElement, 'app-version', environment.version);
  }

  public loadScript(src: string) {
    const body = document.body as HTMLDivElement;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = src;
    body.appendChild(script);
  }

  addGoogleMapsInlineScript(): void {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';

    script.text = `
      (g => {
        var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
        b = b[c] || (b[c] = {});
        var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => {
          await (a = m.createElement("script"));
          e.set("libraries", [...r] + "");
          for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
          e.set("callback", c + ".maps." + q);
          a.src = "https://maps." + c + "apis.com/maps/api/js?" + e;
          d[q] = f;
          a.onerror = () => h = n(Error(p + " could not load."));
          a.nonce = m.querySelector("script[nonce]")?.nonce || "";
          m.head.append(a);
        }));
        d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
      })({
        v: "weekly",
        key: "${environment.googleMapsKey}"
      });
    `;

    this.renderer.appendChild(document.body, script);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.appService.windowSize$.next(event.target.innerWidth);
  }

  @HostListener('window:visibilitychange')
  onVisibilityChange(): void {
    this.appService.visibilityChange$.next('onVisibilityChange' + Math.random().toString());
  }
}
